import React from 'react';

class Select extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            focus: false,
            value: ''
        };
    }

    handleFocus() {
        this.setState({
            focus: true
        })
    }

    handleBlur(event) {
        this.setState({
            focus: false
        })
        if (this.props.onBlur) {
            this.props.onBlur(event)
        }
    }

    handleChange(event) {
        this.setState({
            value: event.target.value
        })
        if (this.props.onChange) {
            this.props.onChange(event)
        }
    }

    componentWillMount() {
        if (this.props.value) {
            this.setState({
                focus: true,
                value: this.props.value
            })
        }
    }

    render () {

        const className = this.state.focus || this.state.value ? 'input-filled' : ''
        const focused = this.state.focus ? 'input-focus' : ''

        return (
            <div className={ `input-container select ${className} ${focused}` }>
                <label htmlFor={ `for_${this.props.name}` }>
                    <span className="label">
                        {this.props.label}
                        <span className="input-helper">{this.props.helper}</span>
                    </span>
                    <select name={this.props.name} id={ `for_${this.props.name}` } onFocus={this.handleFocus.bind(this)} onBlur={this.handleBlur.bind(this)} onChange={this.handleChange.bind(this)}>
                        <option></option>
                        {
                            this.props.options ?
                                this.props.options.map((obj, i) => {
                                    let option = ''
                                    let value = ''
                                    if (Array.isArray(obj)) {
                                        option = obj[1]
                                        value = obj[0]
                                    } else {
                                        option = obj
                                        value = i
                                    }
                                    return <option key={i} value={ value }>{ option }</option>
                                })
                            :
                                <option value="">Please Add Some Options</option>    
                        }
                    </select>
                    <span className="input-error">{this.props.error}</span>
                </label>
            </div>
        );
    }
}

export default Select